import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import { openMultiUpdateOrderModal } from 'App/components/MultiActionModal/MultiUpdateOrder/openMultiUpdateOrderModal';
import AppService from 'App/legacy/AppService';

export default function updateOrder(rb: RequestBuilder, entity: string, multiSelect: MultiSelect) {
	return openMultiUpdateOrderModal({
		customerId: AppService.getCustomerId(),
		filters: rb,
		entity,
		multiSelect
	});
}
